import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Markdown } from '../../../../shared/markdown';
import { Controller, useFormContext } from 'react-hook-form';
import ControlledInput from '../../../../shared/formElements/controlledInput';
import { resetPinConstants } from '../../../../utils/constants/resetPin';

function useQuery(){
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}
interface PinValidationInputsProps {
  serverAuthSuccess: boolean;
  token: string | null;
}

export const PinValidationInputs = ({ serverAuthSuccess, token} : PinValidationInputsProps) => {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext();
  const {
    subHeading,
    defaultValue,
    setPinValidationSubText
  } = resetPinConstants;

  return (
    <>
      <Markdown children={setPinValidationSubText} className="subText" />
      <Controller
        render={(props) => (
          <ControlledInput
            {...props}
            type="text"
            label="Unique Card ID/EAID*"
            fieldName="eaid"
            validation={errors?.eaid?.message}
            width="100%"
          />
        )}
        name="eaid"
        control={control}
        defaultValue={defaultValue.eaid || ''}
      />
      <Controller
        render={(props) => (
          <ControlledInput
            {...props}
            type="text"
            label="Mobile Number*"
            fieldName="phone"
            validation={errors?.phone?.message}
            width="100%"
          />
        )}
        name="phone"
        control={control}
        defaultValue={defaultValue.phone || ''}
      />
      { token ?
        <Controller
          render={(props) => (
            <ControlledInput
              {...props}
              type="text"
              label="New PIN*"
              fieldName="pinCode"
              validation={errors?.pinCode?.message}
              width="100%"
            />
          )}
          name="pinCode"
          control={control}
          defaultValue={defaultValue.pinCode || ''}
        /> : null

    }

    </>
  );
};
